import { Injectable, inject } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs';

import { ConfirmModalService } from '../confirm-modal/confirm-modal.service';

/**
 * Observa novas versões publicadas do app (via Angular Service Worker) e
 * oferece ao usuário recarregar para aplicar a atualização.
 */
@Injectable({ providedIn: 'root' })
export class PwaUpdateService {
  private readonly swUpdate = inject(SwUpdate);
  private readonly confirmModal = inject(ConfirmModalService);

  init(): void {
    if (!this.swUpdate.isEnabled) {
      return;
    }

    this.swUpdate.versionUpdates
      .pipe(filter((event): event is VersionReadyEvent => event.type === 'VERSION_READY'))
      .subscribe(() => {
        this.confirmModal.confirm(
          'Atualização disponível',
          'Uma nova versão do Seu Ingresso Aqui está pronta. Recarregar agora?',
          () => document.location.reload(),
          undefined,
          'Atualizar',
          'Depois',
          'info'
        );
      });
  }
}
